import ModulePagination from '../Public/ModulePagination';

class ListTable {
    pagination = "";
    constructor(){
        this.handlePagination();
    }

    handlePagination = function(){
        const wrapper = document.querySelector('.js-table-wrapper');
        if (wrapper){
            if (wrapper.classList.contains('table-initialized')){

            }
            wrapper.classList.add('table-initialized');
            let handle = wrapper?.querySelector('.pagination-handle');
            const option = {
                paged: 1,
                page_per_view: wrapper.dataset.per ? wrapper.dataset.per : 20,
            }

            const _this = this;
            _this.pagination = new ModulePagination(wrapper.querySelectorAll('.wrapper-item'), handle, option);
            let timeout = null;
            const observer = new MutationObserver(function (mutationsList, observer) {
                for (const mutation of mutationsList) {
                    if (mutation.addedNodes.length) {
                        mutation.addedNodes.forEach(node => {
                            if (node.nodeType === Node.ELEMENT_NODE) {
                                if (node.classList.contains('wrapper-item')){
                                    clearTimeout(timeout);
                                    timeout = setTimeout(function(){
                                        _this.pagination.destroy();
                                        _this.pagination = new ModulePagination(wrapper.querySelectorAll('.wrapper-item'), handle, option);
                                    }, 60);
                                }
                            }
                        });
                    }
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    }
}
export default ListTable;